var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { attrs: { "header-tag": "header" } },
    [
      _c(
        "template",
        { slot: "header" },
        [
          _c("h3", [_vm._v("Latest Jobs")]),
          _vm._v(" "),
          _c(
            "router-link",
            { attrs: { tag: "a", to: "/jobs", exact: "" } },
            [
              _vm._v("\n      View All Jobs\n      "),
              _c("font-awesome-icon", {
                staticClass: "icon",
                attrs: { icon: "angle-right", size: "lg", fixedWidth: "" }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "jobs-swimlanes" },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("h4", { staticClass: "status-registered" }, [
                    _vm._v("\n          Registered\n          "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "badge badge-pill badge-registered float-right"
                      },
                      [_vm._v(_vm._s(_vm.registeredJobs.length))]
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.registeredJobs, function(job) {
                    return _c("JobCard", {
                      key: job.labRegistrationReference,
                      attrs: {
                        labRef: job.labRegistrationReference,
                        jobId: job.jobId,
                        description: job.registrationDescription,
                        clientRef: job.clientRegistrationReference,
                        status: job.status,
                        priority: job.priority,
                        purchaseOrder: job.purchaseOrder,
                        sampleCount: job.numberOfSamples,
                        receivedDate: job.receivedDate,
                        dueDate: job.finalisedDateTime
                      }
                    })
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-col",
                [
                  _c("h4", { staticClass: "status-results-available" }, [
                    _vm._v("\n          Results Available\n          "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "badge badge-pill badge-results-available float-right"
                      },
                      [_vm._v(_vm._s(_vm.finalisedJobs.length))]
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.finalisedJobs, function(job) {
                    return _c("JobCard", {
                      key: job.labRegistrationReference,
                      attrs: {
                        labRef: job.labRegistrationReference,
                        jobId: job.jobId,
                        description: job.registrationDescription,
                        clientRef: job.clientRegistrationReference,
                        status: job.status,
                        priority: job.priority,
                        purchaseOrder: job.purchaseOrder,
                        sampleCount: job.numberOfSamples,
                        receivedDate: job.receivedDate,
                        dueDate: job.finalisedDateTime
                      }
                    })
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-col",
                [
                  _c("h4", { staticClass: "status-complete" }, [
                    _vm._v("\n          Complete\n          "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "badge badge-pill badge-complete float-right"
                      },
                      [_vm._v(_vm._s(_vm.completedJobs.length))]
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.completedJobs, function(job) {
                    return _c("JobCard", {
                      key: job.labRegistrationReference,
                      attrs: {
                        labRef: job.labRegistrationReference,
                        jobId: job.jobId,
                        description: job.registrationDescription,
                        clientRef: job.clientRegistrationReference,
                        status: job.status,
                        priority: job.priority,
                        purchaseOrder: job.purchaseOrder,
                        sampleCount: job.numberOfSamples,
                        receivedDate: job.receivedDate,
                        dueDate: job.finalisedDateTime
                      }
                    })
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29bd582d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29bd582d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LatestJobs.vue
// module id = T65P
// module chunks = 1